import XTbl,{Xtc} from '../../../../components/x-table';
const tbl = new XTbl('', 'manege');

tbl.add(new Xtc('names', 'Name'))
tbl.add(new Xtc('status', '2FA Status'))

export default tbl;

